"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var text_input_field_1 = require("../../../../components/pricing/inputs/text-input-field/text-input-field");

var quantity_field_content_1 = require("../../../../theming/pricing-system/quantity-field.content");

var numeric_validator_1 = require("../../../../utils/validators/numeric-validator");

var QuantityField = function (_super) {
  __extends(QuantityField, _super);

  function QuantityField() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.inputFieldRef = react_1.default.createRef();

    _this.clear = function () {
      var ref = _this.inputFieldRef.current;

      if (ref) {
        ref.clear();
      }
    };

    _this.validate = function () {
      var value = NaN;
      var ref = _this.inputFieldRef.current;

      if (ref) {
        value = Number(ref.validate());
      }

      return value;
    };

    _this.onValidate = function (text) {
      if (!numeric_validator_1.NumericValidator.isWholeNumber(text)) {
        return false;
      }

      var value = Number(text);
      return !!value;
    };

    _this.onSelect = function (value) {
      var onSelect = _this.props.onSelect;

      if (onSelect) {
        onSelect(value ? Number(value) : NaN);
      }
    };

    return _this;
  }

  QuantityField.prototype.render = function () {
    return react_1.default.createElement(text_input_field_1.TextInputField, {
      ref: this.inputFieldRef,
      viewStyle: this.props.viewStyle,
      invalidInputMessage: quantity_field_content_1.QuantityFieldContent.invalidInputMessage,
      label: quantity_field_content_1.QuantityFieldContent.label,
      keyboardType: "numeric",
      onValidate: this.onValidate,
      onSelect: this.onSelect,
      isDisabled: this.props.isDisabled
    });
  };

  return QuantityField;
}(react_1.default.PureComponent);

exports.QuantityField = QuantityField;